module.exports = "<div class=\"project-management\">\n    <div class=\"projects-management-container\">\n        <dbm-list2 [listTitle]=\"'Projects'\" [isProject]=true [listItems]=\"projectsAndGroups\" (onListItemClick)=\"getProjectUsersAndGroups($event.selectedItem)\"></dbm-list2>\n    </div>\n    <project-permission [project]=\"project\" [usersAndGroups]=\"usersAndGroups\" [dataHelper]=\"usersAndGroups\" (onDelete)=\"deleteProject()\"></project-permission>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/usersRolesManagement/project-management/project-management.component.html
// module id = 1856
// module chunks = 0